import { api } from '@services';
import Picture, { IPicture, IPictureApiModel } from '@models/Picture.model';

interface ICreateEquipmentPictures {
  id: string;
  name: string;
  uri?: string;
  file?: File;
  type: 'uri' | 'file';
}

const createEquipmentPictures = async ({
  id,
  name,
  uri,
  type,
  file,
}: ICreateEquipmentPictures): Promise<IPicture> => {
  const formData = new FormData();

  formData.append('name', name);
  formData.append('type', type);

  if (type === 'file' && file) {
    formData.append('file', file);
  } else if (type === 'uri' && uri) {
    formData.append('uri', uri);
  }

  const { data: picture } = await api.post<IPictureApiModel>(
    `/equipments/${id}/picture`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return Picture.fromApiModel(picture);
};

export { createEquipmentPictures };
